module.exports = __webpack_public_path__ + "static/media/quartz_100.11d99cd7.ico";